import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService, SESSION_CHECK_HEADER } from '../services/auth.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  const isApi = req.url.startsWith(environment.apiUrl);
  const isLoginRequest = req.method === 'POST' && req.url === `${environment.apiUrl}/access`;
  const isSessionCheck = req.headers.has(SESSION_CHECK_HEADER);

  const authReq =
    token && isApi && !isLoginRequest
      ? req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        })
      : req;

  return next(authReq).pipe(
    catchError((err: unknown) => {
      if (!(err instanceof HttpErrorResponse) || err.status !== 401 || !isApi || isLoginRequest) {
        return throwError(() => err);
      }

      // GET /access probe itself failed → session is dead.
      if (isSessionCheck) {
        authService.forceUnauthorizedLogout();
        return throwError(() => err);
      }

      // Any other EP 401 → verify user via GET /access; logout only if that is 401.
      authService.handleUnauthorized();
      return throwError(() => err);
    }),
  );
};
